import React from "react";
import Card from "react-bootstrap/Card";
import beak from "../../Assets/baek.png";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            안녕하세요, 저는 <span className="purple">김 산</span>입니다.
            <br />
            저는 인하공업전문대학에서<span className="purple"> 컴퓨터정보공학</span>을 공부했습니다.
            <br />
            <br />
            뒤처지지 않도록 꾸준히 알고리즘을 공부하고 있습니다.
          <br/>
          <br/>
          대외활동
          <br/>
          <p style={{fontSize: "15px"}}>
          한국컴퓨터정보학회 우수논문상 수상
          <br/>
          백준 Tier G4
          </p>
          </p>
          
          <p style={{ color: "rgb(155 126 172)", fontSize: "20px"}}>
            "느려도 멈추지 말기"{" "}
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
